import Sidebar from "./Sidebar";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import API from "../../api";

export default function DashboardLayout({ children, user }) {
    const navigate = useNavigate()
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleLogout = async () => {
        try {
            await API.post("/logout");
            navigate("/");
        } catch (err) {
            console.error("Erreur lors du logout :", err);
        }
    };
    
    return (
<div className="min-h-screen bg-[#0D1117] flex overflow-x-hidden w-full">
            
            {/* Sidebar */}
            <Sidebar open={sidebarOpen} handleLogout={handleLogout} setOpen={setSidebarOpen} />
        
            {/* Contenu principal */}
            <div className="flex flex-col flex-1 min-w-0 xl:ml-64">
        
            {/* Header */}
            <Header
                user={user}
                handleLogout={handleLogout}
                toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
            />
        
            {/* Main content */}
            <main className="flex-1 overflow-y-auto overflow-x-hidden pt-20 px-4 sm:px-8 pb-10">
                {children}
            </main>
            </div>
        </div>
        );
        
    }
